export const adminDisabled3rdPartyApps: string = '<div style="text-align: center; color: #485b67">\
    <a href="" target=""></a>\
    <div style="font-size: 30px; font-weight: bold; margin: 10px;"><b>%GD3P_TITLE%</b></div>\
    <div style="font-size: 18px; margin: 5px;">%GD3P_TEXT_01%</div>\
    <div style="font-size: 18px; margin: 5px;">%GD3P_TEXT_02%</div>\
    <div style="font-size: 18px; margin: 20px;">%GD3P_TEXT_03%</div>\
    <div style="font-size: 18px; font-weight: bold; margin: 5px;">%GD3P_TEXT_04%</div>\
    <div style="font-size: 18px; margin: 20px;">%GD3P_TEXT_05%</div>\
  </div>';
